/** @format */

import AxiosClient from "../AxiosClient";

export const downloadTotalInvoice2 = (requestBody = {}) => {
  const url = `/api/billing/total-invoice-v2`;
  return AxiosClient.post(url, requestBody, {
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error("Error:", error);
    });
};
